import { PDFLayout } from 'components/PDFLayout';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router';
import { ROUTES } from 'shared/constants/ROUTES';
import { getUserProfile, selectUserState, userLogout } from 'shared/redux/slicers/user.slicer';
import { tokenService } from 'shared/services/tokenService';

type Props = {
  component: React.FC;
  exact?: boolean;
  path: string;
};
const { getAuthToken, isAuthenticated } = tokenService();
const PDFRoute: React.FC<Props> = ({ component: Component, exact, path }) => {
  const authToken = getAuthToken();
  const dispatch = useDispatch();
  const { isLoggedIn, user } = useSelector(selectUserState);
  useEffect(() => {
    if (authToken && !isLoggedIn) {
      dispatch(getUserProfile());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, isLoggedIn]);

  useEffect(() => {
    if (user) {
      if (!user.attributes.user_types.includes('casting')) {
        dispatch(userLogout());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <PDFLayout>
      <Route
        component={() => {
          if (isAuthenticated()) {
            return <Component />;
          } else {
            return <Redirect to={ROUTES.LOGIN} />;
          }
        }}
        exact={exact}
        path={path}
      />
    </PDFLayout>
  );
};

export default PDFRoute;
